import { Form } from "../../../core/entities/form";

interface Props {
    form: Form;
}

export function PersonInfo({ form }: Props) {
    return (
        <>
            <table className=" min-w-[460px] table-fixed w-full text-left text-sx font-normal">
                <tbody className={"table-body-info"}>
                    <tr>
                        <td>CPR-nummer</td>
                        <td>{form.citizenSsn}</td>
                    </tr>
                    <tr>
                        <td>Læge</td>
                        <td>{form.citizensDoctorName ?? <>&mdash;</>}</td>
                    </tr>
                    <tr>
                        <td>Lægeklinik</td>
                        <td>{form.citizensDoctorClinic ?? <>&mdash;</>}</td>
                    </tr>
                    <tr>
                        <td>Kommune</td>
                        <td>
                            {form.municipalityName ?? form.municipalityCode ?? (
                                <>&mdash;</>
                            )}
                        </td>
                    </tr>
                </tbody>
            </table>
        </>
    );
}
